import cn from 'classnames';

import { IConDefaultType } from '../types';

export interface INarrativeIconProps extends IConDefaultType {}

export default function NarrativeIcon({ color, className, size = 24, rotate, flip }: INarrativeIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.4999 2.7004C20.9499 2.6204 21.3499 3.0204 21.2699 3.4704C20.8499 5.8704 19.7699 9.4704 17.4699 11.7704C15.9699 13.2704 14.0699 14.0704 12.3699 14.5704L10.0699 15.1704C9.5699 15.3004 9.1199 15.5204 8.7199 15.8304L11.8199 9.6304C12.0199 9.2304 11.8599 8.7304 11.4599 8.5304C11.0599 8.3304 10.5599 8.4904 10.3599 8.8904L7.2599 15.0904C7.2099 14.5904 7.2599 14.0904 7.3899 13.5904L7.9899 11.2904C8.4499 9.5404 9.2899 7.6904 10.7899 6.1904C13.0899 3.8904 16.6899 2.7904 19.0899 2.3904L20.4999 2.7004Z"
          fill={color || 'white'}
        />
        <path d="M9.5001 12.4993L4.2001 20.1993" stroke={color || 'white'} strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </i>
  );
}
